<template>
  <div class="taskAssets">
    <hr />
    <div class="assetsInfo">
      <strong>{{Assets.length}} Assets</strong> -
      <a class="ml-xs" href="#">Download all Assets</a>
      <a class="ml-xs" href="#">View all Assets</a>
    </div>
      <div v-for="Asset in Assets" class="Asset" :key="Asset.id">
        <img class="img-fluid" :src="Asset.photo" alt="Asset" />
        <h5 class="fw-semi-bold">{{Asset.photoName}}</h5>
        <div class="assetButtons">
          {{Asset.weight}}
          <a class="ml-sm" href="#">View</a>
          <a class="ml-sm" href="#">Download</a>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'TaskAssets',
  props: ['Assets'],
};
</script>

<style src="./TaskAssets.scss" lang="scss" scoped />
